import shareConfig from "./share-config.json";

export const PUBLIC_SHARE_URL = shareConfig.publicShareUrl;

// When accessed through an EdgeOne signed preview URL, carry only the two
// EdgeOne access fields into shared links. This does not override a future
// custom-domain URL or leak unrelated query parameters.
export function getRuntimeShareUrl() {
  if (typeof window === "undefined") return PUBLIC_SHARE_URL;
  const { protocol, hostname, origin, pathname, search } = window.location;
  if (protocol !== "https:" || hostname === "localhost" || hostname === "127.0.0.1") {
    return PUBLIC_SHARE_URL;
  }
  const url = new URL(pathname, origin);
  const query = new URLSearchParams(search);
  if (query.has("eo_token") && query.has("eo_time")) {
    url.searchParams.set("eo_token", query.get("eo_token")!);
    url.searchParams.set("eo_time", query.get("eo_time")!);
  }
  return url.toString();
}

export interface SharePersona {
  title: string;
  judgement: string;
}

export function createShareText(persona: SharePersona) {
  return [
    `我在 WMLSTI 五月天人生观测试里测出了「${persona.title}」：`,
    persona.judgement,
    "九张专辑各选一首，你也来试试。",
    getRuntimeShareUrl(),
  ].join("\n");
}

export function createSharePayload(persona: SharePersona) {
  return {
    title: "WMLSTI｜五月天人生观测试",
    text: createShareText(persona),
    url: getRuntimeShareUrl(),
  };
}

export async function invokeShareLink(
  persona: SharePersona,
  share: (data: ShareData) => Promise<void> = (data) => navigator.share(data),
) {
  await share(createSharePayload(persona));
}
